import React from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

export default function RadioButtonsGroup({groupLabel, defaultValue, radioButtons, triggerUpdateInParent}) {
  const [value, setValue] = React.useState(defaultValue);

  const createFormControlLabels = radioButtons.map(r => {
    return <FormControlLabel value={r} control={<Radio />} label={r} />
  })

  const handleChange = (event) => {
    setValue(event.target.value);
    if (event.target.value)triggerUpdateInParent(event.target.value)
  };



  // Disabled = <FormControlLabel value="disabled" disabled control={<Radio />} label="(Disabled option)" />
  return (
    <FormControl component="fieldset">
      <FormLabel component="legend" style={{ marginLeft: 40, marginRight: 40 }}>{groupLabel}</FormLabel>
      <RadioGroup aria-label="gender"style={{ marginLeft: 40, marginRight: 40 }}  name="gender1" value={value} onChange={handleChange}>
        {createFormControlLabels}
      </RadioGroup>
    </FormControl>
  );
}